// React
import React from 'react'
// External Libs
import SwipeableViews from 'react-swipeable-views'
// Material UI
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
// Components
import Conditional from '../common/conditional'
import OrdersKanbanTabs from '../orders-kanban-tabs'
// Styles
import useStyles from './OrdersKanbanLayout.styles'
import OrdersKanbanAdvancedFiltersToolbar from '../orders-kanban-advanced-filters-toolbar'

const OrdersKanbanLayout = ({ children, index, onChangeIndex }) => {
  const componentClasses = useStyles()
  const theme = useTheme()
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
  return (
    <div className={componentClasses.root}>
      <Conditional if={!isMdUp}>
        <OrdersKanbanTabs />
        <OrdersKanbanAdvancedFiltersToolbar />
        <SwipeableViews
          index={index}
          onChangeIndex={onChangeIndex}
          className={componentClasses.swipeableViewsRoot}
        >
          {children}
        </SwipeableViews>
      </Conditional>
      <Conditional if={isMdUp}>
        <OrdersKanbanAdvancedFiltersToolbar />
        <div className={componentClasses.board}>{children}</div>
      </Conditional>
    </div>
  )
}

export default OrdersKanbanLayout
